import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CandidateService {
  /** Candidate flow */
  iscandidateExistURL = 'candidate/validate-token?token=';
  candidateLoginUrl = 'candidate/login';

  constructor(
    private http: HttpClient,
    @Inject('BASE_API_URL') private baseUrl: string) {

  }

  /** check candidate is exist or not */
  isCandidateExist(token): Observable<any> {
    const url = `${this.baseUrl}${this.iscandidateExistURL}`;
    return this.http.get(url + encodeURIComponent(token))
  }

  /** candidate login request */
  candidateLoginRequest(data: any): Observable<any> {
    const url = `${this.baseUrl}${this.candidateLoginUrl}`;
    return this.http.post(url, data);
  }

  /** get getGroupedQuestions */
  getGroupedQuestions(assessmentId): Observable<any> {
    const url = `${this.baseUrl}candidate/assessments/`;
    return this.http.get(url + assessmentId + '/grouped-questions');
  }

  /** get getGroupedQuestions */
  beginAssessmentOrViewQuestion(params: { questionType: string, view: 'full' | 'partial', questionNumber?: number }, assessmentId): Observable<any> {
    return this.http.get(`${this.baseUrl}candidate/assessments/${assessmentId}/view`, { params });
  }

  /** timeSync */
  // timeSync(questionId, assessmentId): Observable<any> {
  //   const url = `${this.baseUrl}candidate/assessments/${assessmentId}/synctime?questionId=${questionId}`;
  //   return this.http.get(url);
  // }

  /** get Next question */
  getNextQuestion(questionType, obj, assessmentId): Observable<any> {
    const url = `${this.baseUrl}candidate/assessments/`;
    // Suppress global loader for auto-save (partialSave) requests to avoid UI flicker
    const isPartialSave = !!obj?.partialSave;
    const options = isPartialSave ? { headers: { 'skip-loader': 'true' } } : {};
    return this.http.post(url + assessmentId + '/save/v1?questionType=' + questionType, obj, options as any);
  }

  /** question number click */
  getQuestionByIndex(assessmentId: string, params: {
    questionType: string,
    questionNumber: number,
    view: 'full' | 'partial',
  }): Observable<any> {
    return this.http.get(`${this.baseUrl}candidate/assessments/${assessmentId}/get-question-by-index`, { params });
  }

  /** submit assessment */
  submitAssessment(questionType, id): Observable<any> {
    const url = `${this.baseUrl}candidate/assessments/`;
    const type = questionType ? `?questionType=${questionType}` : '';
    return this.http.get(url + id + '/submit' + type)
  }

  // runTests(data):Observable <any> {
  //   const url = `${this.baseUrl}candidate/assessments/${data?.assessmentId}/run-tests?question_id=${data.questionId}`;
  //   return this.http.post(url, data);
  // }

  /** run test case for  coding question */
  runTests(data): Observable<any> {
    const url = `${this.baseUrl}candidate/assessments/${data?.assessmentId}/run-tests/v1?question_id=${data.questionId}`;
    return this.http.post(url, data, { headers: { 'skip-loader': 'true' } });
  }

  /** get question for enterprise user */
  getAssessmentQuestionForEnterprise(questionType, assessmentId, questionNumber): Observable<any> {
    const url = `${this.baseUrl}candidate/assessments/`;
    return this.http.get(url + assessmentId + '/get-question-by-index/admin?questionType=' + questionType + '&question=' + questionNumber);
  }

}